// extracted by mini-css-extract-plugin
export default {"container":"_2DcE31","contentWrapper":"_2Ui3cQ","content":"_3X49jq"};